var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegistrarM = function SvgRegistrarM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0c19.326 0 35 15.674 35 35S54.326 70 35 70 0 54.326 0 35 15.674 0 35 0Z",
    fill: "#0A1B57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0v70C15.674 70 0 54.326 0 35S15.674 0 35 0Z",
    fill: "#247EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.481a14.195 14.195 0 0 0-1.502 5.903C12.136 63.795 22.842 70 35 70c12.158 0 22.864-6.205 29.14-15.616a14.312 14.312 0 0 0-1.51-5.903c-4.716-9.297-17.126-7.758-18.729-10.145-1.244-1.855-.503-7.55-.59-9.016-5.809.554-10.763.431-16.572-.122-.08 1.467.597 7.283-.647 9.138-1.604 2.387-14.013.849-18.73 10.145Z",
    fill: "#865E45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.481a14.195 14.195 0 0 0-1.502 5.903C12.136 63.795 22.842 70 35 70V29.672c-2.682-.028-5.364-.2-8.254-.474-.079 1.467.597 7.283-.647 9.138-1.603 2.387-14.013.849-18.73 10.145h-.007Z",
    fill: "#6E4936"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.82 20.908c-.374-.446-.906-.568-1.46-.496a56.11 56.11 0 0 0 .022-1.546c0-2.977-.008-6.629-1.05-8.707-.755-1.524-1.913-2.516-3.272-3.257-5.227-2.825-8.893-2.825-14.12 0-1.366.74-2.517 1.733-3.272 3.257-1.042 2.085-1.05 5.738-1.05 8.707 0 .51.008 1.028.022 1.546-.553-.072-1.085.05-1.46.496-.862 1.035-.481 3.278.36 4.875.31.59.676 1.085 1.222 1.46.223.157.46.272.676.323.367 1.69.877 3.278 1.575 4.702.963 1.97 2.279 3.61 4.055 4.695 2.782 1.704 7.103 1.704 9.886 0 1.776-1.086 3.091-2.725 4.055-4.695.697-1.424 1.208-3.02 1.575-4.702.222-.05.452-.166.675-.324.547-.374.913-.877 1.223-1.46.84-1.596 1.215-3.839.352-4.874h-.015Z",
    fill: "#AB7D5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.613 5.335c-1.366-1.33-3.364-2.1-5.895-2.524-.842-.144-4.66-.13-5.536.022-2.48.424-4.437 1.193-5.788 2.502-3.372 3.271-3.566 9.117-3.013 15.566 2.006-4.02 5.12-5.766 8.858-6.248.892-.115 4.537-.122 5.378-.022 3.803.453 6.981 2.193 9.023 6.27.547-6.45.353-12.295-3.02-15.566h-.007Z",
    fill: "#79B0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 4.774c-2.222 0-4.45.705-7.06 2.114-1.366.74-2.517 1.733-3.272 3.257-1.042 2.085-1.05 5.737-1.05 8.707 0 .51.008 1.028.022 1.546-.553-.072-1.085.05-1.46.496-.862 1.035-.481 3.278.36 4.874.31.59.676 1.086 1.222 1.46a2 2 0 0 0 .676.323c.367 1.69.877 3.279 1.575 4.703.963 1.97 2.279 3.609 4.055 4.694 1.387.856 3.163 1.28 4.946 1.28V4.767L35 4.774Z",
    fill: "#996949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 2.718c-1.18 0-2.38.043-2.826.122-2.48.424-4.436 1.194-5.787 2.502-3.372 3.271-3.567 9.117-3.013 15.566 2.006-4.02 5.12-5.766 8.858-6.248.453-.058 1.625-.086 2.768-.093V2.717Z",
    fill: "#004AB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.068 37.567c-1.769-1.028-3.085-2.574-4.048-4.436-.626-1.208-1.1-3.193-1.452-4.602C27.235 25.502 30.93 24.28 35 24.28c4.07 0 7.758 1.222 10.432 4.25-.352 1.416-.826 3.393-1.452 4.6-.963 1.863-2.272 3.409-4.04 4.437-2.776 1.61-7.09 1.61-9.865 0h-.007Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.068 37.567c-1.769-1.028-3.085-2.574-4.048-4.436-.626-1.208-1.1-3.193-1.452-4.602C27.235 25.502 30.93 24.28 35 24.28v14.487c-1.769 0-3.544-.402-4.932-1.207v.007Z",
    fill: "#DDEAF1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.48a14.195 14.195 0 0 0-1.502 5.904C12.136 63.795 22.842 70 35 70c12.158 0 22.864-6.205 29.14-15.616a14.312 14.312 0 0 0-1.51-5.903c-3.587-7.068-11.618-7.873-15.968-8.901-1.129 3.731-5.745 6.528-11.274 6.528-5.529 0-10.295-2.89-11.324-6.715-4.112 1.143-12.905 1.603-16.702 9.088Z",
    fill: "#E8EDF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.072 39.386c-4.113 1.143-12.906 1.603-16.702 9.088a14.195 14.195 0 0 0-1.503 5.903c5.99 8.987 16.019 15.04 27.494 15.573-1.222-4.012-9.174-30.154-9.282-30.571l-.008.007Z",
    fill: "#6BC7B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.928 39.386c4.113 1.143 12.906 1.603 16.702 9.088a14.194 14.194 0 0 1 1.503 5.903c-5.989 8.987-16.019 15.04-27.494 15.573 1.215-4.005 9.174-30.154 9.282-30.571l.008.007Z",
    fill: "#79B0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.48a14.195 14.195 0 0 0-1.502 5.904C12.136 63.795 22.842 70 35 70V46.101c-5.436-.13-9.922-2.977-10.936-6.708-4.112 1.143-12.905 1.603-16.702 9.088Z",
    fill: "#D4DDE2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.072 39.386c-4.113 1.143-12.906 1.603-16.702 9.088a14.195 14.195 0 0 0-1.503 5.903c5.99 8.987 16.019 15.04 27.494 15.573-1.222-4.012-9.174-30.154-9.282-30.571l-.008.007Z",
    fill: "#004AB3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.804 63.587c-.266-6.112-.158-6.176-.806-.59.267.201.533.395.806.59Z",
    fill: "#21564F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.196 63.587c.266-6.112.166-6.176.805-.59a32.99 32.99 0 0 1-.805.59Z",
    fill: "#2A7269"
  })));
};
export default SvgRegistrarM;